import { connect } from "react-redux";
import { providePopulateData } from "components/utility/hoc/PopulateData";

var ButtonDropdown = require("components/utility/ButtonDropdown");
var ButtonDropdownOption = require("components/utility/ButtonDropdownOption");

var RosterActions = require("lib/actions/RosterActions");
var RosterSelectors = require("lib/selectors/RosterSelectors");
var CurrentUser = require("lib/account/CurrentUser");


@connect(
	(state, props) => {
		// var prefs = RosterSelectors.studentListPrefs({ state }) || {};
		var prefs = {}
		var admin = RosterSelectors.admin({state, id: CurrentUser.get().id})
		
		if (admin && admin.prefs) {
			prefs = admin.prefs;
		}

		return {
			prefs
		}
	},

	(dispatch, props) => ({
		populateData: () => {
            //STEP 1: Grab logged in admin
            return Promise.all([ dispatch(RosterActions.fetchAdmins({
                filters:{ids: [CurrentUser.get().id]}, 
                embeds:['user.prefs'],
                cache: true
            }))])
        },
		onChange: (prefsUpdate, message) => {
			
			// RESETING ALL STUDENT LISTS
			var resetStudentLists = false

			if (confirm("Do you want to apply this setting to all your students? Selecting yes, will override the individual student and class preferences you may have set.") == true) {
				resetStudentLists = true
			} 

			window.wrNotifications.triggerDropDownNotification({
				title: "Information Edited", text: message, icon: "ok-sign"
			});

			return dispatch( RosterActions.updateAdminPrefs({
				id: CurrentUser.get().id,
				resetStudentLists: resetStudentLists,
				update: prefsUpdate
			}))

			// var loc = document.URL
			// 	if (loc.indexOf("roster") > -1) {
			// 		$(document).trigger('roster-update', ["updateOnly"])				
			// }
		},

	})
)

@providePopulateData({waitForLoad:true})
class QuizLimitPreference extends React.Component {
	constructor(props) {
		super();
		autobind(this);
		this.state = { quizCloseTime: props.prefs.quiz_close_time || NEVER_STRING}
		LuckyOrangeClient.tagComponent("OwlShopPreference");
	}

	onOptionChange(value, pos) {
		var preferenceHash = {};
		preferenceHash = { quiz_close_time: value };
		if (value == ALWAYS_STRING) {
			var message = "Students are blocked from taking quizzes until you change adjust your settings."
		} else {
			var message = "You successfully changed the Quiz settings."
		}
		this.props.onChange(preferenceHash, message);
		this.setState({quizCloseTime: value})
	}
	getOptions() {
		var options = []
		options.push(<ButtonDropdownOption onClick={ this.onOptionChange.bind(this, NEVER_STRING) }
						text={ NEVER_VALUE } key={ NEVER_STRING } />)

		options.push(<ButtonDropdownOption onClick={ this.onOptionChange.bind(this, ALWAYS_STRING) }
			text={ ALWAYS_VALUE } key={ ALWAYS_STRING } />)

		_.each(OPENING_OPTIONS, (time) => {
			var text = OPTION_LABEL + time
			options.push(<ButtonDropdownOption onClick={ this.onOptionChange.bind(this, time) }
					text={ text } key={ time } />)
		})
		return options
	}
	render() {
    
    
        var openingOptions = this.getOptions()

        if (this.state.quizCloseTime == NEVER_STRING) {
            var quizCloseTime = NEVER_VALUE
        } else {
            var quizCloseTime = this.state.quizCloseTime

            var sentence = ""
            if (quizCloseTime && quizCloseTime != ALWAYS_STRING){
                sentence = "Students will only able to take quizzes before " + quizCloseTime  + " on Mondays to Fridays."
            } else if (quizCloseTime == ALWAYS_STRING ){
				sentence = "Students are blocked from taking quizzes. To re-enable quizzes, adjust your settings."
			} else {
                sentence = "Students are able to take quizzes at any time."
            }
            var disclaimer = (
                <div className="browserDisclaimer">
                    <p>
                        { sentence } <br/>
                    </p>
                </div>
            )
        }
        var section = (
            <div>
				{ disclaimer }
                <label>
                    <ButtonDropdown text={ quizCloseTime } className="standardsPicker">
                        { openingOptions }
                    </ButtonDropdown>
                </label>
            </div>
        )
    
		
		return (
			<div className="OwlShopPreferenceContainer">
				<p className="selectOwlShopText">
					You can lock quizzes to prevent your students from taking quizzes outside of class time.
				</p>
				{ section }
			</div>
		)
	}
}

var OPENING_OPTIONS = ["1 PM", "2 PM", "3 PM", "4 PM", "5 PM"]
var NEVER_VALUE = "Never close"
var NEVER_STRING = "Never"
var ALWAYS_VALUE = "Always closed"
var ALWAYS_STRING = "Always"
var OPTION_LABEL = "Close quizzes after "

module.exports = QuizLimitPreference;



// WEBPACK FOOTER //
// ./modules/components/users/teachers/preferences/QuizLimitPreference.js